import React from 'react';

import Box from '@mui/material/Box';
import Fade from '@mui/material/Fade';

import LoadingDisplay from './LoadingDisplay';

interface LoadingWrapperProps {
  isLoading: boolean;
  children?: React.ReactNode;
  message?: string;
}

const LoadingWrapper: React.FC<LoadingWrapperProps> = (props) => {
  let { isLoading, children, message = 'Loading...' } = props;

  if (isLoading) {
    return (
      <Fade in={true} timeout={300}>
        <Box sx={{ width: '100%', backgroundColor: '#f1f1f1' }}>
          <LoadingDisplay message={message} />
        </Box>
      </Fade>
    );
  }

  return (
    <Fade in={true} timeout={300}>
      <Box>{children}</Box>
    </Fade>
  );
};

export default LoadingWrapper;
